import React from "react"

const SectionResults = () => (
  <section className="results on-view" id="lp-results">
    <div className="wrap">
      <span className="eyebrow">Case study</span>
      <h2>Results published in Harvard Business Review</h2>
      <p className="lede measure">
        This Los Angeles hospital used our analytics in BPCI Advanced
        (Medicare’s bundled payment program). It spent less than CMS target
        prices and improved outcomes for its patients.
      </p>
      <div className="rgrid">
        <div className="rcol">
          <div className="rcard hero-stat simple">
            <div className="rbig">15%</div>
            <div className="rcap">below CMS target prices</div>
          </div>
          <a
            className="hbr-btn hbr-card"
            href="https://hbr.org/2021/03/how-one-hospital-has-succeeded-in-a-world-of-bundled-payments"
            target="_blank"
            rel="noopener"
          >
            <i>HBR</i>
            <span>Read the article in Harvard Business Review</span>
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M6 3h7v7M13 3L5 11"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
        <div className="rcard">
          <div className="rttl">Better outcomes</div>
          <div className="qgrid">
            <div
              className="qm"
              role="img"
              aria-label="90-day mortality fell from 34 percent to 25 percent"
            >
              <div className="cols">
                <div className="col">
                  <div className="bar before" style={{ "--h": "34" }} />
                  <span>34%</span>
                  <em>Before</em>
                </div>
                <div className="col">
                  <div className="bar after" style={{ "--h": "25" }} />
                  <span>25%</span>
                  <em>After</em>
                </div>
              </div>
              <div className="qlbl">90-day mortality</div>
              <div className="qdelta">9 points lower</div>
            </div>
            <div
              className="qm"
              role="img"
              aria-label="90-day readmissions fell from 30 percent to 25 percent"
            >
              <div className="cols">
                <div className="col">
                  <div className="bar before" style={{ "--h": "30" }} />
                  <span>30%</span>
                  <em>Before</em>
                </div>
                <div className="col">
                  <div className="bar after" style={{ "--h": "25" }} />
                  <span>25%</span>
                  <em>After</em>
                </div>
              </div>
              <div className="qlbl">90-day readmissions</div>
              <div className="qdelta">5 points lower</div>
            </div>
          </div>
          <div className="rfoot">
            Cardiac and medical bundles, compared with the year before the
            hospital began preparing.
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default SectionResults
